import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { Box, Typography } from '@mui/material';
import IndustryMarketPoliciesFormFields from '@Router/NatureOfBusiness/Components/MarketPolicies/IndustryMarketPoliciesFormFields';
import MarketPoliciesOverallFormFields from '@Router/NatureOfBusiness/Components/MarketPolicies/LastYearMarketPoliciesFormFields';
import ProductCharacterFormFields from '@Router/NatureOfBusiness/Components/MarketPolicies/ProductCharacterFormFields';
import { useEffect } from 'react';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { MarketingIndustryTypes } from '../NatureOfBusinessFormProvider/types';
import ExportRatioFormFields from './ExportRatioFormFields';

const MarketPoliciesDescriptionForm = () => {
  const { setValue, getValues, watch } = useNatureOfBusinessForm();

  const [marketType, marketPolicyFields, completedSection] = watch([
    'marketingIndustry.type',
    'marketingIndustry.marketingPolicy',
    'marketingIndustry.completedSection',
  ]);

  const bizGroups = watch('productInformation.businessGroupInfos') ?? [];

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  useEffect(() => {
    if (marketType === MarketingIndustryTypes.SPECIFIC) {
      const bizGroups = getValues('productInformation.businessGroupInfos');
      setValue(
        'marketingIndustry.marketingPolicy',
        bizGroups.map((group, index) => ({
          productNameTh: group.nameTh,
          productNameEn: group.nameEn,
          ...marketPolicyFields[index],
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bizGroups]);

  return (
    <>
      {marketPolicyFields?.map((_, index: number) => (
        <Box
          key={index}
          mt={2}
          p={2}
          border={'1px solid hsla(240, 2%, 90%, 1)'}
        >
          {marketType === MarketingIndustryTypes.SPECIFIC && (
            <Box mb={2}>
              <Typography fontWeight={800} mb={2}>
                {`สายผลิตภัณฑ์ บริการ หรือกลุ่มธุรกิจที่ ${index + 1}`}
              </Typography>
              <ProductCharacterFormFields marketPolicyIndex={index} />
            </Box>
          )}
          <MarketPoliciesOverallFormFields marketPolicyIndex={index} />
          <ExportRatioFormFields
            marketPolicyIndex={index}
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
          <IndustryMarketPoliciesFormFields marketPolicyIndex={index} />
          <Box mt={2}>
            <UploadImageFormFields
              key={`upload-image-${index}-${
                marketPolicyFields?.[index]?.assets?.length || 0
              }`}
              title={'รูปภาพสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา'}
              name={`marketingIndustry.marketingPolicy.${index}`}
              disabledTh={isCompletedTh}
              disabledEn={isCompletedEn}
            />
          </Box>
        </Box>
      ))}
    </>
  );
};

export default MarketPoliciesDescriptionForm;
